<template>
  <aside class="main-sidebar cyber-sidebar">
    <section class="sidebar">
      <div class="user-panel cyber-user-panel">
        <div class="ulogo"></div>
        <div class="left-menu-logo">
          <img src="/resources/logos/BC_LOGO.png" alt="Business Club" />
        </div>

        <div class="info cyber-user-info">
          <p class="cyber-welcome">
            Welcome
            <span class="cyber-username">{{
              $store.getters.currentUser.username
            }}</span>
          </p>

          <template v-if="$store.getters.currentUser.rank != 'regular'">
            <p class="m1 cyber-rank">
              <img
                class="w-50"
                :src="$store.getters.currentUser.rank_icon"
                alt
              />
            </p>
          </template>

          <div class="cyber-user-actions">
            <router-link to="/profile" class="cyber-icon-btn" title="Settings">
              <i class="ion ion-gear-b"></i>
            </router-link>

            <a class="cyber-icon-btn" @click.prevent="logout" title="Logout">
              <i class="ion ion-power"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- sidebar menu -->
      <ul class="sidebar-menu cyber-menu" data-widget="tree">
        <li class="nav-devider"></li>
        <li class="header nav-small-cap">PERSONAL</li>

        <li
          class="treeview"
          :class="active === 'dashboard' ? 'active' : ''"
          @click="selected('dashboard')"
        >
          <router-link to="/dashboard">
            <i class="mdi mdi-view-dashboard"></i>
            <span>Dashboard</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="active === 'plans' ? 'active' : ''"
          @click="selected('plans')"
        >
          <router-link to="/plans">
            <i class="mdi mdi-cube-outline"></i>
            <span>Packages</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="active === 'reports' ? 'active' : ''"
          @click="selected('reports')"
        >
          <router-link to="/reports">
            <i class="mdi mdi-chart-areaspline"></i>
            <span>Reports</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="active === 'network' ? 'active' : ''"
          @click="selected('network')"
        >
          <router-link to="/network">
            <i class="mdi mdi-source-branch"></i>
            <span>Binary</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="active === 'my-referrals' ? 'active' : ''"
          @click="selected('my-referrals')"
        >
          <router-link to="/my-referrals">
            <i class="mdi mdi-rocket"></i>
            <span>Unilevel</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="active === 'leads' ? 'active' : ''"
          @click="selected('leads')"
        >
          <router-link to="/leads">
            <i class="mdi mdi-account-search"></i>
            <span>Leads</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="active === 'financial' ? 'active' : ''"
          @click="selected('financial')"
        >
          <router-link to="/financial">
            <i class="mdi mdi-package-variant-closed"></i>
            <span>Packs</span>
          </router-link>
        </li>

        <li class="header nav-small-cap">MY ACCOUNT</li>

        <li
          class="treeview"
          :class="active === 'balance' ? 'active' : ''"
          @click="selected('balance')"
        >
          <router-link to="/balance">
            <i class="mdi mdi-wallet"></i>
            <span>Wallet</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="active === 'profile' ? 'active' : ''"
          @click="selected('profile')"
        >
          <router-link to="/profile">
            <i class="mdi mdi-account-outline"></i>
            <span>Profile</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="active === 'invoices' ? 'active' : ''"
          @click="selected('invoices')"
        >
          <router-link to="/invoices">
            <i class="mdi mdi-file-document"></i>
            <span>Invoices</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="active === 'marketing' ? 'active' : ''"
          @click="selected('marketing')"
        >
          <router-link to="/marketing">
            <i class="mdi mdi-lightbulb"></i>
            <span>Tools</span>
          </router-link>
        </li>

        <li class="header nav-small-cap">ACTIONS</li>
        <li class="treeview">
          <a class="pointer-cursor" @click.prevent="logout">
            <i class="mdi mdi-logout-variant"></i>
            <span>Log Out</span>
          </a>
        </li>
      </ul>
    </section>
  </aside>
</template>

<style lang="scss" scoped>
.left-menu-logo {
  text-align: center;
  margin: 0.6rem 1.2rem !important;

  img {
    max-width: 100px;
    filter: drop-shadow(0 0 12px rgba(176, 154, 78, 0.25));
    transition: all 0.3s ease;

    &:hover {
      filter: drop-shadow(0 0 20px rgba(176, 154, 78, 0.45));
      transform: scale(1.03);
    }
  }
}

.cyber-user-info {
  text-align: center;
  padding: 0 12px 10px;
}

.cyber-welcome {
  font-size: 0.78rem;
  color: #8a8a82 !important;
  margin-bottom: 3px;
}

.cyber-username {
  font-family: 'Orbitron', sans-serif;
  color: #B09A4E !important;
  text-shadow: 0 0 10px rgba(176, 154, 78, 0.3);
  font-weight: 600;
  font-size: 0.78rem;
}

.cyber-rank {
  margin: 6px 0;

  img {
    filter: drop-shadow(0 0 8px rgba(176, 154, 78, 0.3));
    max-width: 65px;
  }
}

.cyber-user-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 8px;
}

.cyber-icon-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  border: 1px solid rgba(61, 61, 55, 0.8);
  background: rgba(46, 46, 46, 0.5);
  color: #9A998F !important;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    color: #B09A4E !important;
    border-color: rgba(176, 154, 78, 0.3);
    background: rgba(176, 154, 78, 0.08);
    box-shadow: 0 0 12px rgba(176, 154, 78, 0.15);
  }

  i {
    font-size: 0.9rem;
  }
}
</style>

<script>
import { userMixin } from "@/mixins";

export default {
  name: "left-menu",
  data() {
    return {
      active: "",
    };
  },
  mixins: [userMixin],
  created() {
    this.active = this.$route.path.split("/")[1];
  },
  methods: {
    selected(link) {
      this.active = link;
      if (window.innerWidth < 767)
        document.querySelector("#toggle-menu").click();
    },
  },
};
</script>
